import { I18n } from "@assets/strings";

const FIREBASE_ERROR_CODES = new Set([
	"app-not-verified",
	"code-expired",
	"internal-error",
	"invalid-app-credential",
	"invalid-credential",
	"missing-app-credential",
	"network-request-failed",
	"quota-exceeded",
	"too-many-requests",
]);

export function messageForFirebaseError(error: unknown, fallbackKey = "auth.error.default"): string {
	console.error(error);
	const code = readFirebaseCode(error);
	if (code && FIREBASE_ERROR_CODES.has(code)) {
		return I18n.t(`app.firebase.${code}`);
	}
	return I18n.t(fallbackKey);
}

function readFirebaseCode(error: unknown): string | undefined {
	if (!error || typeof error !== "object" || !("code" in error)) {
		return undefined;
	}
	const { code } = error;
	if (typeof code !== "string") {
		return undefined;
	}
	return code.startsWith("auth/") ? code.slice("auth/".length) : code;
}
